import Link from './link'
export {
    Link
}


// WEBPACK FOOTER //
// ./src/decorators/index.ts